import { CustomizationType, Customization } from '../types';

export function getCustomization(customizations: Customization[], type: CustomizationType) {
    const customization = customizations.find((el) => el.type === type);
    if (!customization) return null;
    return customization.data;
}
